import React, { useEffect, useState } from 'react';
type CountdownProps = {
  endsAt: string | null;
  durationMinutes?: number | null;
};
const STORAGE_KEY = 'rk-promo-ends-at';
export function Countdown({
  endsAt,
  durationMinutes
}: CountdownProps) {
  const [target] = useState<number | null>(() => resolveTarget(endsAt, durationMinutes));
  const [remaining, setRemaining] = useState<number | null>(() => target ? Math.max(0, target - Date.now()) : null);
  useEffect(() => {
    if (!target) return;
    const id = window.setInterval(() => setRemaining(Math.max(0, target - Date.now())), 1000);
    return () => window.clearInterval(id);
  }, [target]);
  if (remaining === 0) {
    return <p className="mx-auto max-w-md rounded-2xl border border-line bg-ink px-5 py-4 text-base font-bold text-cream" data-id="element-60" data-mp="372t1shh7kets">
        La promoción de lanzamiento finalizó.
      </p>;
  }
  const units = [{
    label: 'Horas',
    value: remaining === null ? undefined : Math.floor(remaining / 3600000)
  }, {
    label: 'Min',
    value: remaining === null ? undefined : Math.floor(remaining / 60000 % 60)
  }, {
    label: 'Seg',
    value: remaining === null ? undefined : Math.floor(remaining / 1000 % 60)
  }];
  return <div className="flex justify-center gap-2 sm:gap-3" role="timer" aria-live="off" data-id="element-61" data-mp="17rhnota0o8w0">
      {units.map((u, i) => <React.Fragment key={u.label} data-id="element-62" data-mp="12sy3oyezh76a" data-mpi={i}>
          <div className="w-20 rounded-2xl border border-coral/50 bg-ink py-3 text-center sm:w-24" data-id="element-63" data-mp="12tzp9wtmlc29">
            <span className="block text-4xl font-black tabular-nums text-white" data-id="element-64" data-mp="f4evsjzuiweq">
              {u.value === undefined ? '--' : String(u.value).padStart(2, '0')}
            </span>
            <span className="text-[11px] font-black uppercase tracking-widest text-muted" data-id="element-65" data-mp="o4jywhy0b8n3">{u.label}</span>
          </div>
          {i < units.length - 1 && <span className="self-center text-3xl font-black text-coral" aria-hidden="true" data-id="element-66" data-mp="1zhvzmjygzb51">:</span>}
        </React.Fragment>)}
    </div>;
}
function resolveTarget(endsAt: string | null, durationMinutes?: number | null): number | null {
  if (endsAt) return new Date(endsAt).getTime();
  if (!durationMinutes) return null;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored) return Number(stored);
    const t = Date.now() + durationMinutes * 60000;
    window.localStorage.setItem(STORAGE_KEY, String(t));
    return t;
  } catch {
    return Date.now() + durationMinutes * 60000;
  }
}